






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Cdr extends Vue {}
